var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegularWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 320 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "regular_water",
    transform: "matrix(0.3125,0,0,0.16,-335.625,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 0,
    width: 1024,
    height: 2000,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.2,0,0,6.25,946,-562.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,100L140,400L260,400L300,100L100,100Z",
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,100L140,400L260,400L300,100L100,100Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.2827,0,-21.1021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.001,219.149C223.315,213.871 202.745,192.351 180,187.965C167.935,185.638 151.93,186.059 140,190.869",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "13.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.18617,0,-43.3035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350,205.116C350,205.116 301.447,226.874 250,205.116C213.572,189.71 188.177,186.934 160,188.255C112.258,190.493 68.024,222.439 60,238.838",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "13.7px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100,100L140,400L260,400L300,100L100,100Z",
    style: {
      fill: "none",
      stroke: "rgb(52,52,52)",
      strokeWidth: "15.03px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularWater);
export default __webpack_public_path__ + "static/media/regular_water.e8be7053f14613c531adc801bff7add5.svg";
export { ForwardRef as ReactComponent };